<template>
    <svg id="calendar_4_" data-name="calendar (4)" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height"
         viewBox="0 0 15.842 15.57">
        <path id="Exclusion_13" data-name="Exclusion 13"
              d="M15.842,15.569H0V1.093H4.124A1.366,1.366,0,1,1,5.463,2.731a.273.273,0,1,1,0-.546.819.819,0,1,0-.77-1.093h.5a.273.273,0,1,1,0,.546H.546V3.55H15.3V1.639H11.718a1.372,1.372,0,0,1-1.338,1.093.273.273,0,1,1,0-.546.819.819,0,1,0,0-1.639.273.273,0,1,1,0-.546,1.371,1.371,0,0,1,1.338,1.093h4.124V15.568Zm-3.824-3.824v3.278H15.3V11.745Zm-3.824,0v3.278h3.278V11.745Zm-3.824,0v3.278H7.648V11.745Zm-3.824,0v3.278H3.824V11.745ZM12.018,7.921V11.2H15.3V7.921Zm-7.648,0V11.2H7.648V7.921Zm-3.824,0V11.2H3.824V7.921ZM9.833,9.946h0l.9.9a.273.273,0,0,0,.386-.387l-.9-.9.9-.9a.273.273,0,1,0-.386-.387l-.9.9-.9-.9a.273.273,0,1,0-.386.387l.9.9-.9.9a.273.273,0,1,0,.386.387l.9-.9ZM12.018,4.1V7.374H15.3V4.1Zm-3.824,0V7.374h3.278V4.1ZM4.37,4.1V7.374H7.648V4.1ZM.546,4.1V7.374H3.824V4.1Z"
              transform="translate(0 0)" fill="#87a6ff"/>
        <path id="Path_69716" data-name="Path 69716"
              d="M25.273,1.046a.819.819,0,0,1,0,1.639.273.273,0,1,0,0,.546,1.366,1.366,0,0,0,0-2.731.273.273,0,1,0,0,.546Z"
              transform="translate(-18.172 -0.5)" fill="#87a6ff"/>
        <path id="Path_69717" data-name="Path 69717"
              d="M31.273,1.046a.819.819,0,1,1,0,1.639.273.273,0,1,0,0,.546,1.366,1.366,0,1,0,0-2.731.273.273,0,1,0,0,.546Z"
              transform="translate(-22.533 -0.5)" fill="#87a6ff"/>
    </svg>

</template>

<script>
    export default {
        name: "ICalendar",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
